export const CUSTOMER_SITE = 'customer_site';
export const GROUP_ADMIN = 'group-admin';
export const B2B = 'b2b';
export const DISCOUNT_PORTAL = 'discount-portal';
